import RegEx from '../pages/new-order/regEx';

interface CountryInfo {
  reg: RegExp;
  message: string;
  dialingCode: string;
  name: string;
  countryCode: string;
}

const allAboutNorway: CountryInfo = {
  reg: RegEx.orgNumberNorway,
  message: 'The organization number must contain 9 digits',
  dialingCode: '+47',
  name: 'Norway',
  countryCode: 'NO',
};

const allAboutSweden: CountryInfo = {
  reg: RegEx.orgNumberSweden,
  message: 'The organization number must contain 10 digits',
  dialingCode: '+46',
  name: 'Sweden',
  countryCode: 'SE',
};

const allAboutDenmark: CountryInfo = {
  reg: RegEx.numbersOnly,
  message: 'The organization number most contain only digits',
  dialingCode: '+45',
  name: 'Denmark',
  countryCode: 'DK',
};

export const supportedCountries: { [name: string]: CountryInfo } = {
  NORWAY: allAboutNorway,
  SWEDEN: allAboutSweden,
  DENMARK: allAboutDenmark,
};

const generalLookupByCountry = new Map([
  ['NORWAY', supportedCountries['NORWAY']],
  ['SWEDEN', supportedCountries['SWEDEN']],
  ['DENMARK', supportedCountries['DENMARK']],
  ['NO', supportedCountries['NORWAY']],
  ['SE', supportedCountries['SWEDEN']],
  ['DK', supportedCountries['DENMARK']],
]);

export function isOrganisationNumberValid(
  organisationNumber: string,
  country: string
): boolean {
  const countryObj = generalLookupByCountry.get(country.toUpperCase());
  if (!countryObj) {
    throw new Error(`Unknown country ${country}`);
  }

  return organisationNumber.match(countryObj.reg) !== null;
}

export function getMessageForWrongOrgNumber(country: string) {
  const countryObj = generalLookupByCountry.get(country.toUpperCase());
  if (!countryObj) {
    throw new Error(`Unknown country ${country}`);
  }

  return countryObj.message;
}

export function getDialingCode(country: string): string {
  const countryObj = generalLookupByCountry.get(country.toUpperCase());
  if (!countryObj) {
    throw new Error(`Unknown country ${country}`);
  }

  return countryObj.dialingCode;
}

export function isNorway(country?: string): boolean {
  return (
    !!country &&
    (country.toUpperCase() === 'NO' || country.toUpperCase() === 'NORWAY')
  );
}

export function toHumanReadable(country?: string): string {
  const countryObj = generalLookupByCountry.get(country?.toUpperCase() || '');
  if (!countryObj) {
    throw new Error(`Unknown country ${country}`);
  }

  return country ? countryObj.name : '';
}
